interface EnvType {
  APP_NAME: string;
  APP_URL: string;
  BACKEND_URL: string;
  API_POSTFIX: string;
  GOOGLE_OAUTH_CLIENT_ID: string;
}

const env_dictionary: Record<string, EnvType> = {
  local: {
    APP_NAME: "Mohtawa Creative OS",
    BACKEND_URL: import.meta.env.VITE_BACKEND_URL || "http://localhost:5000",
    API_POSTFIX: "/api",
    APP_URL: "http://localhost:3000",
    GOOGLE_OAUTH_CLIENT_ID:
      "806282833824-2c1lks9f713vihqj39rnrur0bias1dnk.apps.googleusercontent.com",
  },
  development: {
    APP_NAME: "Mohtawa Creative OS",
    BACKEND_URL: "https://dev-api.mohtawa.ai",
    API_POSTFIX: "/api",
    APP_URL: "https://dev.mohtawa.ai",
    GOOGLE_OAUTH_CLIENT_ID:
      "806282833824-2c1lks9f713vihqj39rnrur0bias1dnk.apps.googleusercontent.com",
  },
  production: {
    APP_NAME: "Mohtawa Creative OS",
    BACKEND_URL: "https://api.mohtawa.ai",
    API_POSTFIX: "/api",
    APP_URL: "https://mohtawa.ai",
    GOOGLE_OAUTH_CLIENT_ID:
      "806282833824-2c1lks9f713vihqj39rnrur0bias1dnk.apps.googleusercontent.com",
  },
};

/* Unset or unrecognized falls back to `development`, never `production`: both
   deploy workflows set VITE_PUBLIC_ENV explicitly at build time, so this only
   ever applies to a local dev server — where pointing at the live API would be
   the wrong default. Guarding on the key also stops a typo from leaving `env`
   undefined and crashing the app on import. */
const DEFAULT_ENV = "development";
const requested_env = import.meta.env.VITE_PUBLIC_ENV || DEFAULT_ENV;

if (!(requested_env in env_dictionary)) {
  console.warn(
    `Unknown VITE_PUBLIC_ENV "${requested_env}" — falling back to "${DEFAULT_ENV}". Expected one of: ${Object.keys(env_dictionary).join(", ")}.`,
  );
}

export const current_env =
  requested_env in env_dictionary ? requested_env : DEFAULT_ENV;

export const env: EnvType = env_dictionary[current_env];

export const isDevMode =
  current_env === "development" || current_env === "local";
